import * as React from 'react';
const defaultContext = {
    lang: 'et',
    setLang: () => undefined,
    isInsideParent: false,
};
export const LanguageContext = React.createContext(defaultContext);
